import { c as _c } from "react/compiler-runtime";
import { SendMessageUserGuest } from "@/components/modules/auth/components/SendMessageUserGuest/SendMessageUserGuest";
import { useUserConversations } from "@/components/modules/chat/api/queries/useUserConversations";
import { useConversation } from "@/components/modules/chat/hooks/useConversation";
import { useAuth } from "@/components/providers/AuthProvider/AuthProvider";
import { ModalTypeEnum, useModal } from "@/components/providers/modal-provider/ModalProvider";
import { User } from "@/types/me";
import { RealEstateType } from "@/types/real-estate";
import { useCallback, useEffect, useMemo, useState } from "react";
type RealEstateDetailMobileFooterProps = {
  detailData: RealEstateType;
};
export function useRealEstateDetailMobileFooter(t0) {
  const $ = _c(36);
  const {
    detailData
  } = t0;
  const [pendingConversation, setPendingConversation] = useState(false);
  const {
    data: userConversationsData
  } = useUserConversations();
  const {
    handleOpenConversation
  } = useConversation();
  const {
    isAuth,
    userSession: sessionData,
    isPendingAuthData
  } = useAuth();
  const {
    openModal
  } = useModal();
  const availableFrom = detailData.realEstate.roomData?.availableFrom;
  const {
    realEstate,
    user
  } = detailData;
  const isOwner = user?.id === sessionData?.id;
  let t1;
  if ($[0] !== realEstate || $[1] !== user || $[2] !== userConversationsData?.data) {
    t1 = user ? userConversationsData?.data.find(conversation => conversation?.realEstate?.id === realEstate.id)?.id : null;
    $[0] = realEstate;
    $[1] = user;
    $[2] = userConversationsData?.data;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const existingConversation = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setPendingConversation(true);
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleOpenDelayedConversation = t2;
  let t3;
  if ($[5] !== existingConversation || $[6] !== handleOpenConversation || $[7] !== isOwner || $[8] !== isPendingAuthData || $[9] !== pendingConversation || $[10] !== realEstate || $[11] !== sessionData || $[12] !== user) {
    t3 = () => {
      if (pendingConversation && sessionData && !isOwner && !isPendingAuthData) {
        handleOpenConversation({
          realEstateConversationAtributes: {
            image: realEstate?.pictures?.[0],
            title: realEstate?.title
          },
          conversationId: existingConversation,
          realEstateId: realEstate.id,
          recipientId: existingConversation ? undefined : user?.id,
          user: existingConversation ? undefined : user
        });
        setPendingConversation(false);
      }
    };
    $[5] = existingConversation;
    $[6] = handleOpenConversation;
    $[7] = isOwner;
    $[8] = isPendingAuthData;
    $[9] = pendingConversation;
    $[10] = realEstate;
    $[11] = sessionData;
    $[12] = user;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== existingConversation || $[15] !== handleOpenConversation || $[16] !== isOwner || $[17] !== isPendingAuthData || $[18] !== pendingConversation || $[19] !== sessionData || $[20] !== user) {
    t4 = [pendingConversation, sessionData, handleOpenConversation, existingConversation, user, isOwner, isPendingAuthData];
    $[14] = existingConversation;
    $[15] = handleOpenConversation;
    $[16] = isOwner;
    $[17] = isPendingAuthData;
    $[18] = pendingConversation;
    $[19] = sessionData;
    $[20] = user;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  useEffect(t3, t4);
  let t5;
  if ($[22] !== handleOpenConversation || $[23] !== realEstate) {
    t5 = t6 => {
      const {
        conversationId,
        user: user_0
      } = t6;
      handleOpenConversation({
        realEstateConversationAtributes: {
          image: realEstate?.pictures?.[0],
          title: realEstate?.title
        },
        conversationId,
        realEstateId: realEstate.id,
        recipientId: user_0?.id,
        user: user_0
      });
    };
    $[22] = handleOpenConversation;
    $[23] = realEstate;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  const handleOpenMessagesAfterLead = t5;
  let t6;
  if ($[25] !== handleOpenMessagesAfterLead || $[26] !== isAuth || $[27] !== openModal || $[28] !== realEstate || $[29] !== user?.id) {
    t6 = () => {
      if (!isAuth) {
        openModal(ModalTypeEnum.GENERIC_DRAWER, {
          children: <div className="px-4 pb-10"><SendMessageUserGuest realEstateId={realEstate.id} recipientId={user?.id} onLoginSuccess={handleOpenMessagesAfterLead} /></div>
        });
      } else {
        handleOpenDelayedConversation();
      }
    };
    $[25] = handleOpenMessagesAfterLead;
    $[26] = isAuth;
    $[27] = openModal;
    $[28] = realEstate;
    $[29] = user?.id;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  const handleSendMessage = t6;
  let t7;
  if ($[31] !== availableFrom || $[32] !== handleSendMessage || $[33] !== pendingConversation || $[34] !== user) {
    t7 = {
      handleSendMessage,
      pendingConversation,
      setPendingConversation,
      user,
      availableFrom
    };
    $[31] = availableFrom;
    $[32] = handleSendMessage;
    $[33] = pendingConversation;
    $[34] = user;
    $[35] = t7;
  } else {
    t7 = $[35];
  }
  return t7;
}